<template>
	<div class="step-nav type--sans type--s type--b">

		<!-- Prev button -->
		<a
			v-if="!prevOptions.hidden"
			class="step-nav__link link is-prev"
			role="button"
			:class="{ 'is-disabled' : prevOptions.disabled }"
			@click="$emit('prev')"
		>
			<span class="step-nav__link-text">{{ prevOptions.text }}</span>
		</a>

		<!-- Next button -->
		<a
			v-if="!nextOptions.hidden"
			class="step-nav__link link is-next"
			role="button"
			:class="{ 'is-disabled' : nextOptions.disabled }"
			@click="$emit('next')"
		>
			<span class="step-nav__link-text">{{ nextOptions.text }}</span>
		</a>
	</div>
</template>

<script>
export default {
	name: "BookingStepperNav",

	props: {
		next: { type: Object },
		prev: { type: Object }
	},

	computed: {
		prevOptions() {
			return {
				disabled: false,
				hidden: false,
				text: "Prev",
				...this.prev
			}
		},
		nextOptions() {
			return {
				disabled: false,
				hidden: false,
				text: "Next",
				...this.next
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.step-nav {
	background: #fff;
	display: flex;
	flex-direction: row;
	z-index: 1;
}

.step-nav__link {
	align-items: center;
	cursor: pointer;
	display: flex;
	flex-direction: row;
	position: relative;
	text-decoration: none;
	&.is-prev {
		padding-left: 2rem;
	}
	&.is-next {
		margin-left: auto;
		padding-right: 2rem;
	}
	// All icon elements
	&:before,
	&:after {
		content: "";
		position: absolute;
	}
	// Icon background
	&:before {
		background: currentColor;
		border-radius: 50%;
		display: block;
		height: 1.5rem;
		width: 1.5rem;
	}
	// Back button icon background
	&.is-prev:before {
		left: 0;
	}
	// Next button icon background
	&.is-next:before {
		right: 0;
	}
	// Icon arrow
	&:after {
		background-image: linear-gradient(90deg, white 30%, transparent 0),
			linear-gradient(180deg, white 30%, transparent 0);
		display: block;
		height: 0.6rem;
		width: 0.6rem;
	}
	// Back button icon arrow
	&.is-prev:after {
		left: 0.5rem;
		transform: rotate(-45deg);
	}
	// Next button icon arrow
	&.is-next:after {
		right: 0.5rem;
		transform: rotate(135deg);
	}
	&.is-disabled {
		color: $colour-pencil--lightest;
		pointer-events: none;
	}
}
</style>
